import * as React from 'react';
import { useAccountPositionsGesRatValGeShortcut } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const AccountsPositionsGesRatValGEShortcut = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionsGesRatValGeShortcut();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
